export default __webpack_public_path__ + "static/media/icon-bottom-nav-messages.7843fe22.svg";